import axios from 'axios';

export default class AuthoringService {

    generateHTML = (payload) => {

      const customHeaders = {
        appversion: 'app',
        'accept-language': 'en-US,en;q=0.8'
      };

      return axios.post('/api/discussion/generateHTML', { body: payload, headers: customHeaders });
    }    

    fetchDiscussions = (mycloudproxysession, lineOfBusinesses) => {
      return axios.post('/api/discussion/list', {lineOfBusinesses}, {headers: {mycloudproxysession}})
    }

    submitDiscussion = (payload, mycloudproxysession) => {
      return axios.put('/api/discussion/form/submit', payload, {headers: {mycloudproxysession}})
    }

    saveDiscussion = (payload, mycloudproxysession) => {
      return axios.put('/api/discussion/form/save', payload, {headers: {mycloudproxysession}})
    }

    saveSmartLink = (payload, mycloudproxysession) => {
    	return axios.put('/api/smartlink/update', payload, {headers: {mycloudproxysession}});  
     }
}